module.exports = __webpack_public_path__ + "static/media/layout6-vid.3f646c41.svg";